// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"Messages_listContainer__2crXJ","searchInput":"Messages_searchInput__3aqQS","sendMessageBtn":"Messages_sendMessageBtn__3udI2"};